<template>
  <v-container fluid>
    <v-toolbar color="indigo">
      <v-toolbar-title>Bienvenido</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-img :src="homeImage" cover></v-img>
      <v-card-actions>
        <span>
          Para mas informacion acerca de nosotros, por favor dirijase a nuestro
          <a href="https://establecimientosancayetano.business.site/" target="_blank" rel="noopener">
            Sitio web.
          </a>
        </span>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import homeImage from '../assets/escHome.jpeg'

export default {
  name: 'Home',
  data () {
    return {
      homeImage
    }
  }
}
</script>
